/**
 * Validate the input for required Event Planner phone number
 *
 * @name validateEventPlannerPhone
 *
 * @param {Function} callback - Callback function invoked with (err)
 */
function validateEventPlannerPhone(callback) {
	console.log('Validating phone number...');

	const phoneNumber = String(this.collect().get('phone'));
	if (phoneNumber === '0000000000' || phoneNumber === '000-000-0000') {
		const publicError = new Error('Please provide a valid phone number.');
		callback([publicError]);
	} else {
		callback();
	}
}

export {
	validateEventPlannerPhone
}